"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var styles = require("./index.module.css");
var CardButton = function (_a) {
    var _b;
    var className = _a.className, style = _a.style, children = _a.children, link = _a.link, listItem = _a.listItem, onClick = _a.onClick;
    // https://github.com/Microsoft/TypeScript/issues/28768
    var LinkComponent = link ? link[1] : 'button';
    return (React.createElement(LinkComponent, { to: link && link[0], type: "button", onClick: onClick, className: classnames_1.default(styles.cardButton, (_b = {}, _b[styles.listItem] = listItem, _b), className), style: style }, children));
};
exports.default = CardButton;
